export const announceNoteAllJp = [
  [
    {
      releaseDate: "2026-09-07T10:00",
      updatedDate: "2026-09-07T10:00",
      announceTitle: "携帯端末の機種変更をご予定ですか？",
      introduction: "お客様の個人情報を保護するため、infoceanus connectへのアクセスには二要素認証が必要です。connectへのログイン時には、二要素認証の実施を求められる場合があります。\n当サービスではMicrosoft認証を利用しており、Microsoft Authenticatorアプリがインストールされた登録済みのモバイル端末が必要です。",
      conclusion: "その他、infoceanus connectアカウントに関するご質問やお困りごとがございましたら、いつでもJRCS担当者までお気軽にお問い合わせください。\n安全な航海をお祈りしております。",
    },
    {
      importance: [
        "携帯端末の機種変更をご予定の場合は、JRCS担当者までご連絡ください。",
      ],
      descriptions: [
        "新しい端末で安全にconnectをご利用いただけるよう、設定をサポートいたします。",
      ],
      images: [],
    },
  ],
];